module.exports = __webpack_public_path__ + "img/康复中心.8d69cf75.png";